import { render, staticRenderFns } from "./TagViewHeader.vue?vue&type=template&id=4d92a3f3"
import script from "./TagViewHeader.vue?vue&type=script&lang=js"
export * from "./TagViewHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports